const StatusBadge = ({ status }) => {
  const styles = {
    pending: 'bg-gray-100 text-gray-700',
    running: 'bg-blue-100 text-blue-700',
    completed: 'bg-green-100 text-green-700',
    completed_with_errors: 'bg-yellow-100 text-yellow-700',
    failed: 'bg-red-100 text-red-700',
    success: 'bg-green-100 text-green-700',
    skipped: 'bg-yellow-100 text-yellow-700',
    processing: 'bg-blue-100 text-blue-700',
  };

  return (
    <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-medium ${styles[status] || 'bg-gray-100 text-gray-700'}`}>
      {String(status).replaceAll('_', ' ')}
    </span>
  );
};

export default StatusBadge;
